<template>
  <div class="">
    <el-page-header class="page-header" @back="goBack" content="详情">
    </el-page-header>
    <div class="bodyname">
      <div class="nav">
        <h1 class="title">{{ list.title }}</h1>
        <div class="desc">
          <div class="desc-l">{{ list.addtime }}</div>
          <div class="desc-r">公告类别：微炬云功能更新动态</div>
        </div>
      </div>
      <div class="body" v-html="list.content"></div>
      <div>
        <img src="../../../assets/wejuyunlogo.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "notice",
  data() {
    return {
      crm: {},
      list: {},
    };
  },
  mounted() {
    // this.abue();
    this.list = this.$route.query.val;
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  font-size: 34px;
  font-weight: bold;
  text-align: center;
}
.body {
  width: 60%;
  margin: 0 auto;
  margin-top: 5.0rem;
  font-size: 1.8rem;
}
.notice {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem .0rem 12px .0rem rgba(97, 111, 180, 0.2);
}
.notice_nav {
  width: 100%;
  padding: 2.0rem;
  border-bottom: .1rem solid #eeeeee;
}
.notice_nav > div:nth-child(2) {
  color: #8c8c8c;
}
.notice_nav_nav {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.0rem;
}
.notice_nav_nav > div:nth-child(1) {
  display: flex;
  align-items: center;
}
.notice_nav_nav > div:nth-child(2) {
  font-size: 2.0rem;
  color: #363636;
  font-weight: bold;
}
.notice_nav_nav > div:nth-child(1) > span:nth-child(1) {
  margin-right: 2.0rem;
  color: #444444;
  font-size: 2.0rem;
}
.notice_nav_nav > div:nth-child(1) > span:nth-child(2) {
  padding: 0.5rem;
  background-color: #4876e5;
  color: #ffffff;
  cursor: pointer;
}
.bodyname {
  padding: 2.0rem;
}
.bodyname > div:nth-child(3) {
  width: 60%;
  margin: 0 auto;
  text-align: right;
}
.title{
  display: flex;
  font-size: 2.0rem;
  justify-content: center;
}
.desc{
  margin-top: 2.0rem;
  display: flex;
  justify-content: center;
  color: #666;
  font-weight: normal;
  font-size: 1.2rem;
  &-l{
    margin-right: 2.0rem;
  }
}
</style>
